import { cssTheme } from '@uds/theme-utils';
import { styled } from 'linaria/react';
import { css, cx } from 'linaria';
import { Layout } from 'domain/constants/layout';

const img = {
  default: css`
    position: static;
  `,
  fullBackground: css`
    width: 100%;
    max-width: 100%;
    &&& {
      ${cssTheme.breakpoints.sm} {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 50%;
        width: 50%;
        height: 100%;
      }
    }
  `,
  flippedFullBackground: css`
    &&& {
      ${cssTheme.breakpoints.sm} {
        right: 50%;
        left: 0;
      }
    }
  `,
  constrained: css`
    position: static;
    width: 100%;
    height: 100%;
    &&& {
      ${cssTheme.breakpoints.sm} {
        position: absolute;
      }
    }
  `,
};

const root = {
  constrained: css`
    padding-top: ${cssTheme.gu1};
    &&& {
      ${cssTheme.breakpoints.sm} {
        padding-top: 0;
        height: 100%;
      }
    }
  `,
  fullBackground: css`
    &&& ${cssTheme.breakpoints.sm} {
      padding-top: 0;
      position: static;
    }
  `,
};
interface RootProps {
  aspect: 'contain' | 'cover';
  focus: string;
  constrained?: boolean;
}

export const StyledRoot = styled.div<RootProps>`
  & img {
    object-fit: unset;
    object-position: unset;
  }
  &&& {
    ${cssTheme.breakpoints.sm} {
      & img {
        object-fit: ${(props) => props.aspect};
        object-position: ${(props) => props.focus};
    }
  }
`;

export const getClassNames = ({ layout }: { layout: Layout }) => {
  const { flipped, constrainImage } = layout;
  const fullBackground = !constrainImage;
  const flippedFullBackground = flipped && fullBackground;

  return {
    image: cx(
      img.default,
      fullBackground && img.fullBackground,
      flippedFullBackground && img.flippedFullBackground,
      constrainImage && img.constrained,
    ),
    root: cx(constrainImage ? root.constrained : root.fullBackground),
  };
};
